<div class="content-wrapper" *blockUI="'section-block'">
    <div class="content-body">
        <app-content-header [contentHeader]="contentHeader"></app-content-header>

        <div class="row">
            <button type="button" class="btn btn-outline-success ml-1 mb-1"
                *ngIf="transaction?.kindId != 7 && transaction?.status != 3 && authService.isEndpointStatus('PUT.Updateing.UpdateStatusTransaction')"
                (click)=" updateTransactionStatus(transaction?.id,transaction?.kindId,3)">
                <i data-feather="check"></i> Onayla
            </button>
            <button type="button" class="btn btn-outline-danger ml-1 mb-1" *ngIf="transaction?.status != 2 && transaction?.kindId != 7 &&
                 transaction?.status != 3 && 
                authService.isEndpointStatus('PUT.Updateing.UpdateStatusTransaction')"
                (click)="updateTransactionStatus(transaction?.id,transaction?.kindId,2)">
                <i data-feather="x"></i> İptal Et
            </button>
            <button type="button" class="btn btn-outline-warning ml-1 mb-1" (click)="updateTransaction(transaction?.id)"
                *ngIf="authService.isEndpointStatus('GET.Reading.UpdateByIdDetailTransactions')">
                <i data-feather="edit"></i>Düzenle
            </button>
        </div>

        <div class="card">
            <div class="card-body">
                <div class="row">
                    <div class="col-xl-8 col-md-6 col-12">
                        <p><strong>Şirket Adı:</strong></p>
                        <h5 class="card-title">
                            <a href="#/admin/company/{{transaction?.companyId}}">
                                {{ transaction?.companyName }}
                            </a>
                        </h5>
                    </div>
                    <div class="col-xl-4 col-md-12">
                        <div class="d-flex">
                            <div class="status-badge" [ngClass]="getStatusClass(transaction?.status)">
                                {{ getStatusText(transaction?.status,transaction?.kindId) }}
                            </div>
                            <div class="ml-2 badge badge-secondary  status-badge-2" *ngIf="transaction?.docNo">
                                <strong>Teklif No:</strong> {{ transaction?.docNo }}
                            </div>
                        </div>
                    </div>

                </div>

                <!-- Tarih ve Diğer Bilgiler -->
                <div class="row">
                    <div class="col-xl-2 col-md-6 col-sm-12">
                        <strong>Oluşturulma Tarihi:</strong>
                        <p>{{ transaction?.transactionCraetedAt | date:'dd/MM/yyyy' }}</p>
                    </div>
                    <div class="col-xl-2 col-md-6 col-sm-12">
                        <strong>Bitiş Tarihi:</strong>
                        <p>{{ transaction?.validityDate | date:'dd/MM/yyyy' }}</p>
                    </div>
                    <div class="col-xl-3 col-md-6 col-sm-12" *ngIf="transaction?.requestTasks != null">
                        <p><strong>Bağlı Olduğu Talep:</strong></p>
                        <p>{{ transaction?.requestTasks?.title }}</p>
                    </div>
                    <div class="col-xl-3 col-md-6 col-sm-12" *ngIf="transaction?.project?.length > 0">
                        <p class="mb-0"><strong>Bağlı Olduğu Proje:</strong></p>
                        <p class="mb-0">{{ transaction?.project[0]?.projectName }}</p>
                    </div>
                    <div class="col-xl-2 col-md-6 col-sm-12" *ngIf="transaction?.personName">
                        <p>
                            <strong>Firma Sorumlu Kişi:</strong>
                        </p>
                        <p>{{ transaction?.personName }} {{
                            transaction?.personLastName }}</p>
                    </div>
                </div>

                <!-- Ekstra Bilgiler ve Durum -->
                <div class="row" *ngIf="transaction?.transactionPrivateNode">
                    <div class="col-xl-8 col-md-12">
                        <div class="d-flex align-items-center">
                            <p>
                                <strong>Gizli Not:</strong> {{ transaction?.transactionPrivateNode }}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="card">
    <div class="card-body">
        <div class="col-12 mb-2">

            <div class="button-group">
                <div class="col-xl-6 col-md-8 col-sm-12"
                    *ngIf="authService.isEndpointStatus('POST.Writing.CreateTransactionProducts')">
                    <label>Ürün Ekle</label>
                    <ng-select [items]="products" bindLabel="name" bindValue="id" [clearable]="true"
                        (change)="onProductChange($event)">
                    </ng-select>
                </div>

                <div ngbDropdown [placement]="'left'" class="btn-group dropup dropdown-icon-wrapper">
                    <button ngbDropdownToggle type="button" class="btn btn-flat-primary dropdown-toggle-split"
                        rippleEffect>
                        <span [data-feather]="'more-vertical'" class="'dropdown-icon'"></span>
                    </button>
                    <div ngbDropdownMenu>
                        <span ngbDropdownItem (click)="isPrivateDiscountToogle()">
                            İndirim Detaylarını Görüntüle
                        </span>
                    </div>
                </div>

            </div>
        </div>

        <div class="table-responsive">
            <table class="table">
                <thead>
                    <tr>
                        <th style="width: 50%;">Ürün Adı</th>
                        <th>Miktar</th>
                        <th>Birim Fiyatı</th>
                        <th *ngIf="isDiscount">İndirim</th>
                        <th *ngIf="isDiscount">Ara Toplam</th>
                        <th>Net</th>
                        <th>KDV</th>
                        <th>V.D Toplam</th>
                        <th>#</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let transaction of transactionList; let i = index">
                        <td style="width: 50%;"><a
                                (click)="showUpdateTransaction(transaction?.transactionManagemetnProductId)"
                                style="font-weight: bold; color: rgb(0, 89, 255);">{{
                                transaction?.productName }}</a><br><span class="description">{{
                                transaction.description }}</span></td>

                        <td>{{ transaction.productCount }}</td>

                        <td>{{ transaction.productPrice }}</td>
                        <td *ngIf="isDiscount">{{transaction.discountRate}}</td>
                        <td *ngIf="isDiscount">{{transaction.productCount * transaction.productPrice | number:'1.2-2' }}
                        </td>
                        <td>{{(transaction.productCount * transaction.productPrice)-((transaction.productCount *
                            transaction.productPrice) * transaction.discountRate / 100 ) | number:'1.2-2' }}</td>
                        <td>(%{{transaction.taxRate }})</td>
                        <td>
                            {{
                            (((transaction.productCount * transaction.productPrice) -
                            ((transaction.productCount * transaction.productPrice) * transaction.discountRate /
                            100))) +
                            ((((transaction.productCount * transaction.productPrice) -
                            ((transaction.productCount * transaction.productPrice) * transaction.discountRate /
                            100)) *
                            transaction.taxRate) / 100) | number:'1.2-2'
                            }}
                        </td>

                        <td>
                            <div class="button-container">
                                <button class="btn btn-icon btn-icon rounded-circle btn-flat-danger"
                                    [disabled]="transactionList.length < 2"
                                    *ngIf="authService.isEndpointStatus('DELETE.Writing.RemoveTransactionProduct')"
                                    (click)="deleteTransaction(transaction.transactionManagemetnProductId)">
                                    <i data-feather="x"></i>
                                </button>
                            </div>
                        </td>
                    </tr>
                    <tr *ngIf="totalAmount !== null">
                        <td colspan="9" style="text-align: right;">
                            <div class="col-md-12 d-flex justify-content-end">
                                <div class="invoice-total-wrapper">
                                    <div class="invoice-total-item">
                                        <p class="invoice-total-title">Toplam Miktar:</p>
                                        <p class="invoice-total-amount">{{ sumCount() }}</p>
                                    </div>
                                    <div class="invoice-total-item">
                                        <p class="invoice-total-title">Brüt Toplam:</p>
                                        <p class="invoice-total-amount">{{ sumGross() | number:'1.2-2' }}</p>
                                    </div>
                                    <div class="invoice-total-item">
                                        <p class="invoice-total-title">Toplam İndirim:</p>
                                        <p class="invoice-total-amount">{{ sumDiscount() | number:'1.2-2' }}</p>
                                    </div>
                                    <div class="invoice-total-item">
                                        <p class="invoice-total-title">Net Toplam:</p>
                                        <p class="invoice-total-amount">{{ sumNetTotal() | number:'1.2-2' }}</p>
                                    </div>
                                    <div *ngFor="let item of transactionCurrencyTotal" class="invoice-total-item">
                                        <p class="invoice-total-title">Toplam Tutar ({{ item.currency }}):</p>
                                        <p class="invoice-total-amount">{{ item.totalAmount | number:'1.2-2' }}</p>
                                    </div>
                                    <div *ngFor="let item of transactionDiscountTotal" class="invoice-total-item">
                                        <p class="invoice-total-title">KDV Toplam %({{ item.taxRate }}):</p>
                                        <p class="invoice-total-amount">{{ item.totalTax | number:'1.2-2' }}</p>
                                    </div>
                                    <hr class="my-50" />
                                    <div class="invoice-total-item">
                                        <p class="invoice-total-title">Genel Toplam:</p>
                                        <p class="invoice-total-amount">{{ calculateGeneralTotal() | number:'1.2-2'
                                            }}</p>
                                    </div>
                                </div>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>